import { useEffect } from 'react';

export default function ScriptsThankYouPage() {
  useEffect(() => {
    document.title = "Your Script Kit Is Ready — TAKEOFF";

    // Google Ads purchase conversion
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16917911601/PURCHASE',
        value: 97.0,
        currency: 'USD',
      });
    }

    // Meta Pixel purchase event ($97 USD — matches page URL trigger)
    if (typeof window.fbq === 'function') {
      // Ensure the new pixel is initialized
      try { window.fbq('init', '1492271452643120'); } catch (e) {}
      window.fbq('track', 'Purchase', {
        value: 97.0,
        currency: 'USD',
        content_name: 'Contractors Ad Script Kit',
      });
    }
  }, []);

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-8"
      style={{ 
        background: '#050505', 
        color: '#fff', 
        fontFamily: "'Manrope', sans-serif" 
      }}
    >
      <div 
        className="text-center"
        style={{ 
          background: '#111', 
          border: '1px solid rgba(255,255,255,0.08)',
          padding: '3rem',
          maxWidth: '520px'
        }}
      >
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
        <h1 
          style={{ 
            fontFamily: "'Barlow Condensed', sans-serif", 
            fontWeight: 700, 
            textTransform: 'uppercase',
            fontSize: '2rem',
            marginBottom: '0.75rem'
          }}
        >
          YOUR SCRIPT KIT IS READY.
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '2rem' }}>
          Download instantly. Start filming today.
        </p>
        <a 
          href="/scripts/downloads/contractors-ad-script-kit.pdf"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '1rem 2rem',
            fontSize: '1rem',
            fontWeight: 600,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none',
            background: '#baf265',
            color: '#000',
            fontFamily: "'Manrope', sans-serif",
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
            transition: 'all 0.15s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = '#c8f57a';
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = '#baf265';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          DOWNLOAD THE KIT (PDF)
        </a>
        <p style={{ marginTop: '2rem', fontSize: '0.8rem', color: 'rgba(255,255,255,0.3)' }}>
          Also emailed to you. Questions? <a href="mailto:info@thetakeoffgroup.com" style={{ color: '#fff' }}>info@thetakeoffgroup.com</a>
        </p>
      </div>
    </div>
  );
}
